import { colors } from "@mui/material";

export const Moisture_Colors = [
  colors.orange.A700,
  colors.lime.A700,
  colors.yellow[800],
  colors.cyan.A700,
];